import LoadingSpinner from './LoadingSpinner';
import React from 'react';

/** Универсальный компонент таблицы
  children - Пагинация
  columns - массив с ключами key, title, render, handleSearch
  data - данные с бэкенда
  если key = actions - в render передается все values в ряде
 **/

const Table = (props) => {
  const { error, loading, columns, data, children, emptyText = 'Результаты не найдены' } = props;

  if (loading) {
    return (
      <div className="text-gray-500">
        <LoadingSpinner style={'h-[500px] flex items-center justify-center'} loading={true} />;
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-8">
      {error ? (
        <p className="text-red-500 text-center">Ошибка: {error.error || 'Не удалось загрузить данные'}</p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm sm:text-base">
              <thead>
                <tr className="text-left text-gray-500 text-xs sm:text-sm border-b border-gray-200">
                  {columns.map((col, index) => {
                    return (
                      <th key={`${col.key}-${index}`} className="px-4 pt-2 pb-4 uppercase">
                        {col.title}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {!data || data?.length === 0 ? (
                  <tr>
                    <td colSpan={2} className="text-gray-700 p-4 whitespace-nowrap">
                      {emptyText}
                    </td>
                  </tr>
                ) : (
                  data?.map((row, index) => {
                    return (
                      <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100 transition-colors`}>
                        {columns.map((col, index) => (
                          <td key={index} className="py-2 px-4 text-gray-700">
                            {col.render ? col.render(col.key === 'actions' ? row : row[col.key]) : row[col.key]}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {children ? children : null}
        </>
      )}
    </div>
  );
};

export default Table;
